import { render } from "./ModalConfirm.vue?vue&type=template&id=5cf75b46"
import script from "./ModalConfirm.vue?vue&type=script&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__